import axiosInstance from "../AxiosInstance";
import { URLS } from "../API/API endpoints";
import { store } from "../Redux/store";
import i18next from "i18next";

const { login } = store.getState();


export const getAllSalesman = async (company_id, search, limit, offset) => {
  try {
    const payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
     "company_id": company_id,
    "search": search, //optional search with phone_no , salesman_no, name,
    "limit":limit,
    "offset":offset
      //  store_id:store_id,
    };
    const response = await axiosInstance.post(URLS.GET_SALESMAN, payload);
    // console.log("RESSSSS USER", response);

    return response.data;
  } catch (error) {
    return error;
  }
};

export const createSalesman = async (payload) => {
  try {
    const response = await axiosInstance.post(URLS.CREATE_SALESMAN, payload);
    // console.log("RESSSSS USER", response);

    return response.data;
  } catch (error) {
    return error;
  }
};

export const updateSalesman = async (payload) => {
  try {
    const response = await axiosInstance.post(URLS.UPDATE_SALESMAN, payload);
    // console.log("RESSSSS USER", response);

    return response.data;
  } catch (error) {
    return error;
  }
};